import React from 'react';

type Props = {
  id: string | number;
  name: string;
  description?: string;
  image?: string;
  sku?: string;
  brand?: string;
  price?: string | number;
  currency?: string;
  availability?: 'InStock' | 'OutOfStock' | 'PreOrder' | string;
  url?: string;
};

export default function ProductJsonLd({
  id,
  name,
  description,
  image,
  sku,
  brand,
  price,
  currency = 'INR',
  availability = 'InStock',
  url,
}: Props) {
  const product = {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    '@id': id ? String(id) : undefined,
    name,
    description: description || undefined,
    sku: sku || undefined,
    brand: brand ? { '@type': 'Brand', name: brand } : undefined,
    image: image ? [image] : undefined,
    offers:
      price !== undefined
        ? {
            '@type': 'Offer',
            url: url || undefined,
            price: String(price),
            priceCurrency: currency,
            availability: `https://schema.org/${availability}`,
          }
        : undefined,
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(product) }}
    />
  );
}
